module.exports = __webpack_public_path__ + "img/item_part_speed_sensor.f9f7fc58.png";